var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElement81(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.9 241",
    style: {
      enableBackground: "new 0 0 407.9 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "149.6,240.5 75.1,240.5 0.6,120.5 75.1,0.5 149.6,0.5  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.8,73.2c3.4,0,4.9,0.5,6.2,1.5c1.6,1.2,2.5,3.3,2.5,5.5s-0.9,4.3-2.3,5.5c-1.5,1.2-3,1.6-6.1,1.6H81v8.1 h-3.5V73.2H83.8z M81,84.1H84c1.4,0,2.5-0.1,3.4-0.8c0.9-0.5,1.6-1.7,1.6-3.2s-0.7-2.6-1.6-3.2c-1-0.6-2.1-0.7-3.5-0.7H81V84.1z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.3,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H96.3z M107.2,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.4,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.6,83.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.4,79.1h3v2.8c1.2-1.9,3.3-3.3,6.2-3.3c5.6,0,8.2,4.7,8.2,8.7c0,4.6-3.3,8.5-8.2,8.5 c-3.4,0-5.4-1.9-6.1-3.2v2.7v5.9h-3.1V79.1z M151.7,87.2c0-2.7-1.9-5.7-5.7-5.7c-1.6,0-3,0.6-4,1.7c-1,1-1.6,2.5-1.6,4.1 s0.6,3,1.6,4c1,1,2.5,1.7,4,1.7C149.4,93,151.7,90.4,151.7,87.2L151.7,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.1,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H160.1z M170.9,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H170.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.2,73.2h3.1v12.3l6.4-6.5h3.8l-7.3,7.2l7.5,9.1h-3.6l-6.7-8.4v8.4h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.3,81.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.9,73.2h3.1v3.3h-3.1V73.2z M202.9,79.1h3.1v16.3h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.8,95.4h-3.1l-6.2-16.3h3.3l4.5,12.4l4.5-12.4h3.3L217.8,95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.5,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H227.5z M238.4,85.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.5,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.8,79.1h3.3l3.8,12.3l3.5-11.4h2.6l3.5,11.4l3.8-12.3h3.2l-5.4,16.3h-3L273.7,84l-3.4,11.4h-3 L261.8,79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.4,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H289.4z M300.2,85.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H300.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.5,89.7c-1,3.5-4.2,6.2-8.3,6.2c-5.3,0-8.7-4.1-8.7-8.6c0-4.8,3.7-8.6,8.6-8.6c3.9,0,7.4,2.4,8.4,6.3 h-3.2c-0.8-2.2-2.9-3.4-5.1-3.4c-1.6,0-2.8,0.5-4,1.6c-1,1-1.6,2.5-1.6,4.1c0,3.4,2.5,5.7,5.6,5.7c2.7,0,4.4-1.7,5.1-3.3H322.5z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M325.2,73.2h3.1v5.6v2.5c1-1.9,3.2-2.8,5.3-2.8c2.5,0,4.2,0.8,5.2,2.3c1,1.4,1.4,3.4,1.4,5.6v8.9h-3.1v-8.8 c0-1.5-0.3-2.8-0.9-3.7c-0.7-0.9-1.8-1.4-3.4-1.4c-1.7,0-2.8,0.6-3.5,1.5c-0.7,0.9-1,2-1,3.1v9.2h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351.5,83.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.3,88.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H360.3z M371.2,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M377.3,73.2h3.1v22.2h-3.1V73.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.8,117.5h-2.2v-2.4h2.2V114c0-4.9,3.8-5.2,6.1-5.2v2.5c-1.1,0-3,0-3,2.9v1h3v2.4h-3v13.9h-3.1V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.2,131.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.9c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V131.4z M92.2,112.6h-3v-4h3V112.6z M98.3,112.6h-3v-4h3V112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.3,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.7,129.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V129.5z M126.4,123.2c0,3.1,2.2,5.7,5.6,5.7c1.6,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C129,117.5,126.4,119.9,126.4,123.2L126.4,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.8,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H146.8z M157.7,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171,119.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H171z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.8,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H179.8z M190.7,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.8,109.2h3.1v22.2h-3.1V109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204,109.2h3.1v22.2H204V109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.4,119.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H218.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.3,125.7c-1,3.5-4.2,6.2-8.3,6.2c-5.3,0-8.7-4.1-8.7-8.6c0-4.8,3.7-8.6,8.6-8.6c3.9,0,7.4,2.4,8.4,6.3 h-3.2c-0.8-2.2-2.9-3.4-5.1-3.4c-1.7,0-2.8,0.5-4,1.6c-1,1-1.6,2.5-1.6,4.1c0,3.4,2.5,5.7,5.6,5.7c2.7,0,4.4-1.7,5.1-3.3H241.3z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.1,109.2h3.1v5.6v2.5c1-1.9,3.2-2.8,5.3-2.8c2.5,0,4.2,0.8,5.2,2.3c1,1.4,1.4,3.4,1.4,5.6v8.9H256v-8.8 c0-1.5-0.3-2.8-0.9-3.7c-0.7-0.9-1.8-1.4-3.4-1.4c-1.6,0-2.8,0.6-3.4,1.5c-0.7,0.9-1,2-1,3.1v9.2h-3.1V109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,131.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V131.4z M265.3,123.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C267.5,117.5,265.3,120.2,265.3,123.3L265.3,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.2,117.5H282v-2.4h2.2V114c0-4.9,3.8-5.2,6.1-5.2v2.5c-1,0-3,0-3,2.9v1h3v2.4h-3v13.9h-3.1V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.8,117.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.2v2.4h-3.2v13.9h-3.1V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.4,109.2h3.1v22.2h-3.1V109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.6,109.2h3.1v3.3h-3.1V109.2z M309.6,115.1h3.1v16.3h-3.1V115.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.9,125.7c-1,3.5-4.2,6.2-8.3,6.2c-5.3,0-8.7-4.1-8.7-8.6c0-4.8,3.7-8.6,8.6-8.6c3.9,0,7.4,2.4,8.4,6.3 h-3.2c-0.8-2.2-2.9-3.4-5.1-3.4c-1.7,0-2.8,0.5-4,1.6c-1,1-1.6,2.5-1.6,4.1c0,3.4,2.5,5.7,5.6,5.7c2.7,0,4.4-1.7,5.1-3.3H332.9z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M335.7,109.2h3.1v5.6v2.5c1-1.9,3.2-2.8,5.3-2.8c2.5,0,4.2,0.8,5.2,2.3c1,1.4,1.4,3.4,1.4,5.6v8.9h-3.1 v-8.8c0-1.5-0.3-2.8-0.9-3.7c-0.7-0.9-1.8-1.4-3.4-1.4c-1.7,0-2.8,0.6-3.5,1.5c-0.7,0.9-1,2-1,3.1v9.2h-3.1V109.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.5,151.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.6,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H88.6z M99.5,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.6,145.2h3.1v22.2h-3.1V145.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.9,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H114.9z M125.7,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H125.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.8,167.4h-3.1l-6.2-16.3h3.3l4.5,12.4l4.5-12.4h3.3L138.8,167.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.2,167.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V167.4z M148.8,159.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C151,153.5,148.8,156.2,148.8,159.3L148.8,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.3,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.5,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.4,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H197.4z M208.2,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H208.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.9,148.3h-5.1v-3.1h13.7v3.1h-5.1v19.1h-3.5V148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.9,145.2h3.1v5.6v2.5c1-1.9,3.2-2.8,5.3-2.8c2.5,0,4.2,0.8,5.2,2.3c1,1.4,1.4,3.4,1.4,5.6v8.9h-3.2 v-8.8c0-1.5-0.3-2.8-0.9-3.7c-0.7-0.9-1.8-1.4-3.4-1.4c-1.6,0-2.8,0.6-3.4,1.5c-0.7,0.9-1,2-1,3.1v9.2h-3.1V145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.9,160.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H255.9z M266.8,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,151.1h2.9v2.3c0.7-1.4,2.6-2.8,4.9-2.8c1.5,0,3.1,0.4,4.2,1.7c0.4,0.4,0.9,1.3,1,1.6 c0.3-0.5,0.6-1,1.2-1.6c1-1,2.5-1.7,4.3-1.7c1.5,0,3.2,0.4,4.4,1.6c1.4,1.5,1.8,3,1.8,6.1v9h-3.1v-8.9c0-1.3-0.2-2.7-0.9-3.6 c-0.6-0.8-1.4-1.3-2.9-1.3c-1.4,0-2.5,0.6-3.1,1.6c-0.7,1-0.8,1.9-0.8,3.3v9h-3.1v-9c0-1.3-0.1-2.3-0.7-3.2 c-0.6-1-1.6-1.6-3.1-1.6c-1.5,0-2.5,0.7-3.1,1.6c-0.6,0.9-0.9,2-0.9,3.3v8.9H273V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.8,160.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H303.8z M314.6,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H314.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.8,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.9,167.4h-3.3v-3.9h3.3V167.4z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement81);
export default __webpack_public_path__ + "static/media/Element 81.b95679fd37e25654e3337e86ac73f4d7.svg";
export { ForwardRef as ReactComponent };